/** Source is authoritative. Labels are only a compatibility path for old summaries. */
export function bookingDomain(booking) {
  const source = String(booking?.source || '').toLowerCase()
  const label = source || String(booking?.type || booking?.tag || '').toLowerCase()
  if (/racquet|padel|tennis/.test(label)) return 'racquet'
  if (/dining/.test(label)) return 'dining'
  if (/golf/.test(label)) return 'golf'
  if (/fitness/.test(label)) return 'fitness'
  if (/spa/.test(label)) return 'spa'
  if (/hotel|rooms|accommodation/.test(label) || (!source && label === 'reservation')) return 'hotel'
  return label || 'booking'
}

export function canonicalBookingId(booking) {
  return booking?.bookingId ?? booking?.booking_id ?? booking?.id ?? null
}

/** @returns {{domain: string, id: string, club: string, member: string} | null} */
export function bookingIdentity(booking, { club = '', member = '' } = {}) {
  const id = canonicalBookingId(booking)
  if (id === null || id === '') return null
  return { domain: bookingDomain(booking), id: String(id), club: String(club), member: String(member) }
}

export function bookingIdentityKey(booking, scope) {
  const identity = bookingIdentity(booking, scope)
  return identity ? JSON.stringify(identity) : null
}
